import React from 'react';
import { Helmet } from 'react-helmet';

// favicons
import faviconIco from './assets/favicon.ico';
import favicon16 from './assets/favicon-16x16.png';
import favicon32 from './assets/favicon-32x32.png';
import faviconApple from './assets/apple-touch-icon.png';

export default function DIFavicon() {
  return (
    <Helmet>
      <link id="favicon" rel="apple-touch-icon" sizes="180x180" href={faviconApple} />
      <link id="favicon" rel="icon" type="image/png" sizes="32x32" href={favicon32} />
      <link id="favicon" rel="icon" type="image/png" sizes="16x16" href={favicon16} />
      <link id="favicon" rel="icon" type="image/x-icon" href={faviconIco} />
    </Helmet>
  );
}
